"use client";

import React, { ComponentProps, useMemo } from "react";
import { Asset } from "@thenounproject/lingo-core";
import { useSelection } from "@contexts/SelectedItemsProvider";
import ActionsMenu from "@features/context-menus/ActionMenu/ActionsMenu";

type Props = Pick<ComponentProps<typeof ActionsMenu>, "open" | "position" | "close"> & {
  assets: Asset[];
};

const AssetLibraryActionMenu: React.FC<Props> = ({ open, position, close, assets }) => {
  const selection = useSelection("assetLibrary");

  const inspectables = useMemo(
    () => assets?.filter(a => selection.includes(a?.id)).map(a => ({ asset: a })) ?? [],
    [assets, selection]
  );

  if (!open || !inspectables.length) return null;

  return (
    <ActionsMenu
      open={true}
      position={position}
      close={close}
      inspectables={inspectables}
      hPos="floatRight"
      vPos="floatBelow"
      source="asset-library-context-menu"
    />
  );
};

export default AssetLibraryActionMenu;
